export default __webpack_public_path__ + "static/media/image11.7b30156d.jpg";